import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';

const MAX_BYTES = 15 * 1024 * 1024;

/**
 * @param {string} name
 * @returns {string}
 */
function safeFileName(name) {
  const base = (name || 'attachment').replace(/[^a-zA-Z0-9._-]/g, '_');
  return base.slice(0, 120) || 'attachment';
}

/**
 * Upload a ticket attachment to Firebase Storage.
 * @param {import('firebase/storage').FirebaseStorage} storage
 * @param {string} ticketId
 * @param {File} file
 * @returns {Promise<{ url: string, path: string, name: string }>}
 */
export async function uploadTicketAttachment(storage, ticketId, file) {
  if (!ticketId || !file) {
    throw new Error('Ticket and file are required for upload.');
  }
  if (file.size > MAX_BYTES) {
    throw new Error('File must be 15 MB or smaller.');
  }

  const fileName = `${Date.now()}_${safeFileName(file.name)}`;
  const path = `uploads/tickets/${ticketId}/${fileName}`;
  const storageRef = ref(storage, path);
  await uploadBytes(storageRef, file, {
    contentType: file.type || 'application/octet-stream',
  });
  const url = await getDownloadURL(storageRef);
  return { url, path, name: file.name || fileName };
}
